import React, { useContext, useEffect, useState } from 'react'
import HotHeader from './hot-header'
import { GlobalStoreContext } from 'Components/store'
import HotLayout from 'Components/new/hot/hot-layout'
import HotCommunityItem from 'Components/new/hot/hot-community-item'
import getFocusCheYouList from 'New/community/services/getFocusCheYouList'

interface IHotCarCicleProps {
  onClickTitle?(): void
  onClickItem?(item: { id?: string; name?: string }): void
}

const MyCommunity = ({ onClickTitle, onClickItem }: IHotCarCicleProps) => {
  const { state } = useContext(GlobalStoreContext)
  const user_id = state.userData?.user_id

  const [focusCheYouList, setFocusCheYouList] = useState<any[]>([])

  useEffect(() => {
    if (!user_id) {
      return
    }
    getFocusCheYouList({ profile_user_id: user_id, count: 6 }).then((res) => {
      setFocusCheYouList(res || [])
    })
  }, [user_id])

  return focusCheYouList.length ? (
    <>
      <HotLayout
        className="tw-bg-white tw-px-16 tw-mb-12 tw-w-full md:tw-pb-0 tw-pb-12 tw-rounded-2"
        smRows={1}
        smCols={3}
        gap={6}
        slideClass="tw-w-1/3 md:tw-w-full"
        slideCount={focusCheYouList?.slice(0, 6).length || 0}
        title={
          <HotHeader
            title={'我的车友圈'}
            herf={`/user/gzcyq/${user_id}`}
            as={`/user/gzcyq/${user_id}`}
            moreButton={true}
            onClick={onClickTitle}
          />
        }
      >
        {({ index }) => {
          const item = focusCheYouList[index]
          return (
            <HotCommunityItem
              id={item?.series_id || item?.motor_id}
              name={item?.name}
              coverUrl={item?.img_url}
              fansCount={item?.fans_count}
              onClick={() => {
                if (onClickItem)
                  onClickItem({
                    id: item?.series_id || item?.motor_id,
                    name: item?.name,
                  })
              }}
            />
          )
        }}
      </HotLayout>
    </>
  ) : null
}
export default MyCommunity
